import config from "config/config";
import NavButton from "modules/common/components/HeaderNav/NavButton";
import { VIEW_CLAIM_STATUS_GTM, VIEW_CLAIM_STATUS_MP } from "modules/common/trackingConsts";
import CheckCompensationButton from "modules/common/components/HeaderNav/CheckCompensationButton";
import { useTranslations } from "contexts/LocalizationContext";
import type { ActionButtonProps } from "./ActionButton.d";

const ActionButton = ({ activeButtonOption }: ActionButtonProps) => {
  const translations = useTranslations();

  return {
    "view-claim-status": (
      <NavButton
        href={`${config.webappUrl}/claims-and-flights`}
        title={translations("view_claim_status")}
        trackingEvents={{ gtmEvent: VIEW_CLAIM_STATUS_GTM, mixpanelEvent: VIEW_CLAIM_STATUS_MP }}
        dataTestId="top-navbar-view-status-button"
      />
    ),
    "check-compensation": <CheckCompensationButton />,
  }[activeButtonOption];
};

export default ActionButton;
